import { produce } from "immer";
import {
  ADD_RATE,
  ADD_RATE_FAILURE,
  ADD_RATE_SUCCESS,
  //
  DELETE_RATE,
  DELETE_RATE_FAILURE,
  DELETE_RATE_SUCCESS,
  //
  EDIT_RATE,
  EDIT_RATE_FAILURE,
  EDIT_RATE_SUCCESS,
  //
  FETCH_RATES,
  FETCH_RATES_FAILURE,
  FETCH_RATES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_RATE_ADD_MODAL,
} from "./constants";

export const initialState = {
  isFetchingRates: false,
  rates: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentRate: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  //
  rateAddModal: {
    open: false,
    isEditing: false,
  },
};

const HourlyRateReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_RATES:
        draft.isFetchingRates = true;
        draft.rates = [];
        break;
      case FETCH_RATES_SUCCESS:
        draft.isFetchingRates = false;
        draft.rates = action.payload;
        break;
      case FETCH_RATES_FAILURE:
        draft.isFetchingRates = false;
        draft.rates = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentRate = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentRate = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentRate = {};
        break;
      // Add
      case ADD_RATE:
        draft.isSubmitting = true;
        break;
      case ADD_RATE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_RATE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_RATE:
        draft.isSubmitting = true;
        break;
      case EDIT_RATE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_RATE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_RATE:
        draft.isDeleting = true;
        break;
      case DELETE_RATE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_RATE_FAILURE:
        draft.isDeleting = false;
        break;
      //
      case TOGGLE_RATE_ADD_MODAL:
        draft.rateAddModal = action.payload;
        break;

      default:
        return state;
    }
  });

export default HourlyRateReducer;
